import type {
  RemoteVendorProduct,
  RemoteVendorProductVariant,
} from "../../../../features/interfaces";
import { buildRemoteVariantUrl } from "./buildRemoteVariantUrl";

export type VendorRemoteMappingSelection = {
  vendor_remote_id: string;
  vendor_remote_name: string;
  vendor_remote_url: string;
};

/** Pure mapping from a remote catalog pick → product form fields (SRP). */
export function mapRemoteSelectionToFormFields(
  product: RemoteVendorProduct,
  variant: RemoteVendorProductVariant
): VendorRemoteMappingSelection {
  const isDefaultVariant =
    !variant.title ||
    variant.title.toLowerCase() === "default title" ||
    variant.title.toLowerCase() === "default";

  const name = isDefaultVariant
    ? product.title
    : `${product.title} — ${variant.title}`;

  return {
    vendor_remote_id: variant.id,
    vendor_remote_name: name,
    vendor_remote_url: buildRemoteVariantUrl(product.url, variant.id),
  };
}

export function pickDefaultVariant(
  product: RemoteVendorProduct
): RemoteVendorProductVariant | null {
  if (!product.variants?.length) return null;
  return product.variants[0];
}
